import { createSlice } from '@reduxjs/toolkit'
import WSUtils from '../../utils/ws-utils';
import { loadMessages } from './messages-reducer';

let store = null;

export const watchlistSlice = createSlice({
  name: 'watchlist',
  initialState: {
    value: {
      own: [],
      others: {},
    }
  },
  reducers: {
    addOwn: (state, { payload }) => {
      const mid = payload?.mid;
      const watchlist = state.value.own;
      const item =`mid|${mid}`;
      if (!!mid && !watchlist.includes(item)) {
        WSUtils.send({
          action: 'begin-watch-mid',
          mid: mid
        });
        store.dispatch(loadMessages({ mid }));
        // watchlist.push(item);
        // state.value.own = watchlist;
      }
    },
    removeOwn: (state, { payload }) => {
      const mid = payload?.mid;
      const watchlist = state.value.own;
      const item =`mid|${mid}`;
      if (!!mid && watchlist.includes(item)) {
        WSUtils.send({
          action: 'end-watch-mid',
          mid: mid
        });
        // state.value.own = watchlist.filter(_item => _item !== item)
      }
    },
    updateOwn: (state, { payload }) => {
      state.value.own = payload?.watchlist || [];
    },
    connectSelf: (state, action) => {
      state.value.own = [];
    },
    disconnectSelf: (state, action) => {
      state.value.own = [];
    },
    updateForOther: (state, { payload }) => {
      const watcher = payload?.watcher;
      const cid = watcher?.cid;
      const watchlist = payload?.watchlist?.SET || [];
      state.value.others[cid] = {
        watcher, watchlist
      };
    },
    connectOther: (state, { payload }) => {
      const cid = payload.cid;
      state.value.others[cid] = {
        watcher: payload,
        watchlist: [],
      };
    },
    disconnectOther: (state, { payload }) => {
      const cid = payload.cid;
      if (!!cid && !!state.value.others[cid]) {
        delete state.value.others[cid];
      }
    },
  },
})

export const { addOwn, removeOwn, updateOwn, connectSelf, disconnectSelf } = watchlistSlice.actions;
export const { updateForOther, connectOther, disconnectOther } = watchlistSlice.actions;

export function configureWithStore(_store) {
  if (!store) {
    store = _store;

    WSUtils.addConnectHandler('update-own-watchlist--connect', () => {
      store.dispatch(connectSelf())
    })
    WSUtils.addDisconnectHandler('update-own-watchlist--disconnect', () => {
      store.dispatch(disconnectSelf())
    })
    WSUtils.addMessageHandlerForEvent('update-own-watchlist', payload => {
      store.dispatch(updateOwn(payload.data))
    });
    WSUtils.addMessageHandlerForEvent('user-connect', payload => {
      store.dispatch(connectOther(payload.data))
    });
    WSUtils.addMessageHandlerForEvent('user-disconnect', payload => {
      store.dispatch(disconnectOther(payload.data))
    });
    WSUtils.addMessageHandlerForEvent('update-other-watchlist', payload => {
      store.dispatch(updateForOther(payload.data))
    });
  }
}

export default watchlistSlice.reducer